import swal from "sweetalert2";
import { pluralize } from "humanize-plus";

export async function confirmDirtySubmission(dirtyFieldNames, numDirtyDetails) {
	try {
		const result = await swal.fire({
			title: "Unsaved Values",
			html: `The following changes have been detected:
					<br/>
					<br/>
					<ul>
						${dirtyFieldNames.map(fieldName => { return `<li>${fieldName}</li>`; }).join("")}
						${numDirtyDetails > 0 ? `<li>${dirtyFieldNames.length > 0 ? "and " : ""}${numDirtyDetails} ${pluralize(numDirtyDetails, "detail")}</li>` : ""}
					</ul>
					<br/>
					Would you like to save and complete?`,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Save and Complete"
		});
		return !result.dismiss;
	}
	catch(err) {
		return false;
	}
}